import type { NSLoader } from '../ns-services/ns-loader-service.js';

// Where the app must reload to drop the old company's records (accepting an invitation, creating a company, switching
// company, another tab switching): the nodeStream shutter closes completely first, the work runs behind it, then the page
// reloads, starts behind the closed shutter and opens once the new page has its data. Nothing on the page changes while the
// shutter is still closing. If the work fails, the shutter opens again and the error goes back to the caller. A loader
// that can't animate (none, or not rendered) never stops the work or the reload.
export async function runBehindShutter(
  loader: NSLoader | undefined,
  message: string,
  work: () => Promise<unknown>,
  url = '/',
) {
  try {
    await loader?.startLoading(undefined, message);
  } catch {
    // The work and the reload matter more than the animation
  }
  try {
    await work();
  } catch (err) {
    try {
      await loader?.finishLoading();
    } catch {
      // As above
    }
    throw err;
  }
  window.location.assign(url);
}

// The shutter closes, then the page reloads: nothing to do behind it
export function reloadBehindShutter(loader: NSLoader | undefined, message: string, url = '/') {
  return runBehindShutter(loader, message, async () => undefined, url);
}
